module.exports = __webpack_public_path__ + "static/04-7b6d5304804db432f4caa3cd803d4b3a.jpg";